import { createStore } from 'vuex'

import { data } from '../shared'

const state = () => ({
  view: 'loading',
  pageTitle: undefined,
  sections: [],
  selectedCard: undefined,
  billboardItem: undefined,
  initialState: true, // for determining if billboard item was swapped
})

const mutations = {
  setView(state, view) {
    state.view = view
  },
  setPageTitle(state, pageTitle) {
    state.pageTitle = pageTitle
  },
  setSections(state, sections) {
    state.sections = sections
  },
  addSection(state, section) {
    if (section.sectionIndex > -1) {
      state.sections.splice(section.sectionIndex, 0, section.section)
    }
  },
  setSelectedCard(state, card) {
    state.selectedCard = card
  },
  setBillboardItem(state, item) {
    state.billboardItem = item
  },
  invalidateInitialState(state) {
    state.initialState = false
  },
}

const actions = {
  async loadAllData({ commit }) {
    const allData = await data.getAllData()
    commit('setSections', allData.sections)
    commit('setPageTitle', allData.billboard.pageTitle)

    // Listen for async data
    document.addEventListener('t3m-LeicaProducts-Products-List', (e) => {
      const section = JSON.parse(e.detail.flxData)
      const sectionIndex = e.detail.flxDataIndex
      if (section) {
        section.async = true
        commit('addSection', { section: section, sectionIndex: sectionIndex })
      }
    })
  },
  setView({ commit }, view) {
    commit('setView', view)
  },
  setPageTitle({ commit }, pageTitle) {
    commit('setPageTitle', pageTitle)
  },
  selectCard({ commit }, cardComponent) {
    commit('setSelectedCard', cardComponent ? cardComponent : undefined)
  },
  setBillboardItem({ commit }, cardComponent) {
    commit('setBillboardItem', cardComponent ? cardComponent : undefined)
  },
  invalidateInitialState({ commit }) {
    commit('invalidateInitialState')
  },
}

const getters = {}

export const store = createStore({
  // strict: process.env.NODE_ENV !== "production",
  state,
  mutations,
  actions,
  getters,
})
